import { Box, Skeleton as MuiSkeleton, Stack, useMediaQuery, useTheme } from '@mui/material';
import CurveLeft from 'components/pages/my-plan/assets/curve-left.svg?react';
import CurveLeftMobile from 'components/pages/my-plan/assets/curve-left-mobile.svg?react';
import CurveRight from 'components/pages/my-plan/assets/curve-right.svg?react';
import CurveRightMobile from 'components/pages/my-plan/assets/curve-right-mobile.svg?react';
import { memo } from 'react';
import { range } from 'utils/range';

const STEP_SIZE = 104;
const STEP_VERTICAL_SPACING = 121;
const CURVE_OFFSET_FROM_STEP = 52;
const STEPS_COUNT = 3;
const CONTAINER_HEIGHT = (STEPS_COUNT - 1) * STEP_VERTICAL_SPACING + STEP_SIZE;

const SectionSkeleton = memo(() => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const CurveSvgRight = isDesktop ? CurveRight : CurveRightMobile;
  const CurveSvgLeft = isDesktop ? CurveLeft : CurveLeftMobile;
  const curveWidth = isDesktop ? 268 : 123;

  return (
    <Stack sx={{ alignItems: 'center', gap: 4 }}>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 2, width: { xs: 284, md: 450 } }}>
        <Box sx={{ flex: 1, height: '1px', bgcolor: '#ECECEC' }} />
        <MuiSkeleton variant="rounded" sx={{ width: 100, height: 16, borderRadius: '8px' }} />
        <Box sx={{ flex: 1, height: '1px', bgcolor: '#ECECEC' }} />
      </Stack>

      <Box sx={{ position: 'relative', width: { xs: 284, md: 450 }, height: CONTAINER_HEIGHT, mt: 4 }}>
        <Box
          sx={{
            position: 'absolute',
            top: CURVE_OFFSET_FROM_STEP,
            left: isDesktop ? 108 : 114,
          }}
        >
          <CurveSvgRight width={curveWidth} height={71} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: STEP_VERTICAL_SPACING + CURVE_OFFSET_FROM_STEP,
            left: 53,
          }}
        >
          <CurveSvgLeft width={curveWidth} height={71} />
        </Box>

        {range({ length: STEPS_COUNT }).map((i) => (
          <MuiSkeleton
            key={i}
            variant="circular"
            sx={{
              position: 'absolute',
              width: STEP_SIZE,
              height: STEP_SIZE,
              top: i * STEP_VERTICAL_SPACING,
              left: i % 2 === 0 ? 0 : { xs: 178, md: 320 },
            }}
          />
        ))}
      </Box>
    </Stack>
  );
});

export const MyPlanSkeleton = memo(() => (
  <Stack
    sx={{
      alignItems: 'center',
      gap: 20,
      width: { xs: '100%', md: 584 },
      mx: 'auto',
      px: { xs: 5, md: 0 },
      py: { xs: 4, md: 10 },
    }}
  >
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 4,
        width: '100%',
        px: { xs: 4, md: 5 },
        height: { xs: 75, md: 86 },
        borderRadius: '16px',
        bgcolor: '#F4F4F4',
      }}
    >
      <MuiSkeleton variant="circular" sx={{ width: 44, height: 44, flexShrink: 0 }} />
      <Stack sx={{ gap: 1, flex: 1, minWidth: 0 }}>
        <MuiSkeleton variant="rounded" sx={{ width: 50, height: 14, borderRadius: '4px' }} />
        <MuiSkeleton variant="rounded" sx={{ maxWidth: 180, width: '60%', height: 18, borderRadius: '4px' }} />
      </Stack>
    </Stack>

    <SectionSkeleton />
    <SectionSkeleton />
  </Stack>
));
